import { css } from '@emotion/core';
export const content = function content() {
  let isExpanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return /*#__PURE__*/css("flex-grow:", isExpanded ? 1 : 0, ";transition:flex-grow 250ms ease-out;");
};
var _ref = {
  name: "14pavtc",
  styles: "mask-image:linear-gradient( to top,transparent,rgba(0,0,0,0.5) calc(min(50%,75px) * 0.45),black min(50%,75px) );"
};
export const wrapper = _ref2 => {
  let fade = _ref2.fade;
  return /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:flex-start;transition:max-height 250ms linear;position:relative;", fade && _ref);
};